import React from 'react';

const QADisplay = ({ data }) => {
  if (!data) {
    return <div className="p-4">No chat data available</div>;
  }

  try {
    // Parse the JSON string into an array
    let chats = JSON.parse(data);

    // Check if chats is an array
    if (!Array.isArray(chats)) {
      return <div className="p-4">Invalid chat data format</div>;
    }

    // Sort chats by id in ascending order
    chats = chats.sort((a, b) => {
      // Handle cases where id might be a string
      const idA = typeof a.id === 'string' ? parseInt(a.id) : a.id;
      const idB = typeof b.id === 'string' ? parseInt(b.id) : b.id;
      return idA - idB;
    });

    return (
      <div className="space-y-6">
        {chats.map((chat) => (
          <div key={chat.id} className="space-y-4">
            {/* Question */}
            {chat.message && (
              <div className="flex flex-col">
                <div className="bg-blue-50 p-4 rounded-lg text-blue-800">
                  {chat.message}
                </div>
              </div>
            )}

            {/* Answer */}
            {chat.response && (
              <div className="flex flex-col">
                <div className="bg-green-50 p-4 rounded-lg text-green-800">
                  {chat.response}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  } catch (error) {
    console.error('Error parsing chat data:', error);
    return <div className="p-4">Error parsing chat data</div>;
  }
};

export default QADisplay;